var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2185 13.9783C11.4931 14.2531 11.9383 14.2529 12.2128 13.9783L15.2252 10.9658C15.4999 10.6913 15.4999 10.246 15.2252 9.97156C14.9507 9.6969 14.5056 9.6969 14.2309 9.97156L12.4187 11.7838V6.70312C12.4187 6.31476 12.1038 6 11.7156 6C11.3273 6 11.0125 6.31476 11.0125 6.70312V11.7838L9.2003 9.97156C8.92564 9.6969 8.48051 9.6969 8.20586 9.97156C7.93138 10.246 7.93138 10.6913 8.20586 10.9658L11.2185 13.9783Z",
    fill: "#0E4C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7282 15.791H8.70312C8.31494 15.791 8 16.1058 8 16.4941C8 16.8823 8.31494 17.1973 8.70312 17.1973H14.7282C15.1164 17.1973 15.4313 16.8823 15.4313 16.4941C15.4313 16.1058 15.1166 15.791 14.7282 15.791Z",
    fill: "#0E4C54"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 4.5,
    stroke: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecord);
export default __webpack_public_path__ + "static/media/icon-record.f06e8f0547e78638aa98d21798d279b0.svg";
export { ForwardRef as ReactComponent };